import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1214854546/src/client/src/app/(public)/[sport]/teams/[team]/[year]/header.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1214854546/src/client/src/app/(public)/[sport]/teams/[team]/[year]/team-profile.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1214854546/src/client/src/components/layout/subnav.tsx");
